;(function () {
  'use strict'

  angular.module('contrast.servers').factory('ServerService', ServerService)

  function ServerService(
    $q,
    ServiceUtils,
    permissions,
    ServerFactory,
    serverVulnsApiConfig,
    LicenseFactory,
    FeaturesService,
    serverConfirmAndApplyProtectLicenseService,
    AGENT_FEATURE
  ) {
    'ngInject'

    var _licensesApplied = 0

    var service = {
      get: get,
      applyLicense: applyLicense,
      launchApplyProtectionDialog: launchApplyProtectionDialog,
      toggleDefend: toggleDefend,
      toggleAssess: toggleAssess,
      getLibStats: getLibStats,
      getVulnSeverityBreakdown: getVulnSeverityBreakdown,
      getVulnStatusBreakdown: getVulnStatusBreakdown,
      getVulnRuleBreakdown: getVulnRuleBreakdown,
      getServerActivityByInterval: getServerActivityByInterval,
      getAttackStatusBreakdown: getAttackStatusBreakdown,
      getAttackTypeBreakdown: getAttackTypeBreakdown,
      getRemediationPolicyViolations: getRemediationPolicyViolations,
      isServerProtectEligible: isServerProtectEligible,
      getServerProperties: getServerProperties,
      isNotProtectionLicensesAvailable: isNotProtectionLicensesAvailable,
      isServerProtectionInvalidLanguage: isServerProtectionInvalidLanguage,
      isServerProtectionValid: isServerProtectionValid,
      getAppTraces: getAppTraces,
      getServersQuickFilters: getServersQuickFilters,
      getFiltersCatalogs: getFiltersCatalogs,
      getFiltersByType: getFiltersByType
    }

    return service

    function isNotProtectionLicensesAvailable(server, protection) {
      return (
        permissions.isRASPEnabled() &&
        !server.license.licensed &&
        protection.breakdown.unused <= 0
      )
    }

    function isServerProtectionInvalidLanguage(server, protection) {
      return (
        permissions.isRASPEnabled() &&
        !server.license.licensed &&
        protection.breakdown.unused > 0 &&
        !isServerProtectEligible(server, true)
      )
    }

    function isServerProtectionValid(server, protection) {
      return (
        permissions.isRASPEnabled() &&
        !server.license.licensed &&
        protection.breakdown.unused > 0 &&
        isServerProtectEligible(server, true)
      )
    }

    function get(serverId) {
      return ServerFactory.getServer(serverId)
        .then(function (response) {
          return response.data.server
        })
        .catch(ServiceUtils.handleError)
    }

    function getServerProperties(serverId) {
      return ServerFactory.getServerProperties(serverId)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function toggleDefend(serverId) {
      return ServerFactory.toggleDefend(serverId).catch(
        ServiceUtils.handleError
      )
    }

    function getLibStats(serverId) {
      return ServerFactory.getLibStats(serverId)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getVulnSeverityBreakdown(serverId) {
      return ServerFactory.getVulnSeverityBreakdown(serverId)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getVulnStatusBreakdown(serverId) {
      return ServerFactory.getVulnStatusBreakdown(serverId)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getVulnRuleBreakdown(serverId) {
      return ServerFactory.getVulnRuleBreakdown(serverId)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getServerActivityByInterval(serverId, interval) {
      return ServerFactory.getServerActivityByInterval(serverId, interval)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getAttackStatusBreakdown(serverId) {
      return ServerFactory.getAttackStatusBreakdown(serverId)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getAttackTypeBreakdown(serverId) {
      return ServerFactory.getAttackTypeBreakdown(serverId)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getRemediationPolicyViolations(serverId) {
      return serverVulnsApiConfig
        .getRemediationPolicyViolations(serverId)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function applyLicense(servers) {
      if (!angular.isArray(servers)) {
        servers = [servers]
      }
      _licensesApplied = 0
      return _applyLicensesAsync(servers).then(function () {
        return {
          licensesApplied: _licensesApplied
        }
      })
    }

    //from http://stackoverflow.com/questions/25704745/how-do-i-sequentially-chain-promises-with-angularjs-q
    function _applyLicensesAsync(arr) {
      return arr.reduce(function (promise, item) {
        return promise.then(function () {
          return _applyLicense(item)
        })
      }, $q.when(''))
    }

    function _applyLicense(server) {
      return LicenseFactory.applyProtectionLicense(server.server_id)
        .then(function () {
          _licensesApplied++
        })
        .catch(ServiceUtils.handleError)
    }

    function launchApplyProtectionDialog(server) {
      return serverConfirmAndApplyProtectLicenseService.applyLicense(
        server,
        true
      )
    }

    function isServerProtectEligible(server, skipLoad) {
      return FeaturesService.isAgentFeatureEnabled(
        AGENT_FEATURE.PROTECTION,
        server.language,
        skipLoad
      )
    }

    function getAppTraces(serverId) {
      return ServerFactory.getAppTraces(serverId)
        .then(ServiceUtils.handleResolve('data.applications'))
        .catch(ServiceUtils.handleError)
    }

    function toggleAssess(serverId) {
      return ServerFactory.toggleAssess(serverId)
        .then(
          ServiceUtils.handleResolve('data', {
            log: ServiceUtils.LOGGER.SUCCESS
          })
        )
        .catch(ServiceUtils.handleError)
    }

    function getServersQuickFilters(serverId) {
      return ServerFactory.getServersQuickFilters(serverId)
        .then(ServiceUtils.handleResolve('data.filters'))
        .catch(ServiceUtils.handleError)
    }

    function getFiltersCatalogs() {
      return ServerFactory.getFiltersCatalogs().then(
        ServiceUtils.handleResolve('data.catalogs')
      )
    }

    function getFiltersByType(filterId, searchFilters) {
      return ServerFactory.getFiltersByType(filterId, searchFilters).catch(
        ServiceUtils.handleError
      )
    }
  }
})()
